export default __webpack_public_path__ + "static/media/INEX-ETHEREUM.137f4c1c.png";